<app-alert-bar></app-alert-bar>

<header class="white-header">
    <div class="container">
        <div class="left-side">
            <div class="logo selenium-header-logo">
                <a [routerLink]="[isStudent ? '/student' : '/']" title="Homepage">
                    <img [src]="getLogo()" alt="PBS LearningMedia logo" />
                </a>
            </div>
            <div *ngIf="isStudent" class="for-students-mark">FOR STUDENTS</div>
            <div
                *ngIf="(isStudent && localizationLogo) || !isStudent || isHomePage"
                class="vertical-bar"
                [ngStyle]="{
                    'background-color': !isHomePage ? 'rgba(0,0,0,0.3)' : ''
                }"
            ></div>
            <div
                class="localization"
                *ngIf="(isStudent && localizationLogo) || !isStudent || isHomePage"
            >
                <app-localization-confirm *ngIf="!isStudent"></app-localization-confirm>
                <div
                    ngbDropdown
                    #localizationDropdown="ngbDropdown"
                    [autoClose]="true"
                    class="dropdown"
                    [ngClass]="{ 'is-student': isStudent && !isHomePage }"
                    (click)="closeRightHandMenus()"
                >
                    <div
                        *ngIf="!localizationLogo && !isStudent"
                        class="localize-dropdown selenium-localize-dropdown"
                        ngbDropdownToggle
                    >
                        <button class="text selenium-choose-station-button">Choose Station</button>
                    </div>
                    <div
                        tabindex="0"
                        *ngIf="localizationLogo && !isStudent"
                        class="localize-dropdown has-logo"
                        ngbDropdownToggle
                    >
                        <img
                            class="localize-logo"
                            [src]="localizationLogo"
                            [alt]="fullCommonName + ' logo'"
                        />
                    </div>
                    <div
                        tabindex="0"
                        *ngIf="localizationLogo && isStudent"
                        class="localize-dropdown has-logo"
                    >
                        <img
                            class="localize-logo"
                            [src]="localizationLogo"
                            [alt]="fullCommonName + ' logo'"
                        />
                    </div>
                    <div ngbDropdownMenu>
                        <div class="close-localization-dropdown-top-wrapper">
                            <button (click)="localizationDropdown.close()">
                                <app-icon [type]="'X'"></app-icon>
                            </button>
                        </div>
                        <app-localization></app-localization>
                        <div class="close-localization-dropdown-bottom-wrapper">
                            <button (click)="localizationDropdown.close()">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-side">
            <div class="auth">
                <div class="register" *ngIf="!userService.isLoggedIn()">
                    <ng-container>
                        <span *ngIf="!isStudent"
                            ><app-register [nextURL]="nextUrl"></app-register
                        ></span>
                        <span *ngIf="isStudent"
                            ><app-register [student]="true" [nextURL]="nextUrl"></app-register
                        ></span>
                    </ng-container>
                </div>
                <div *ngIf="userService.isLoggedIn()" class="logged-in selenium-logged-in">
                    <div ngbDropdown>
                        <div class="auth-dropdown" ngbDropdownToggle>
                            <span>
                                <app-icon [type]="'User'"></app-icon>
                                <span class="name">
                                    {{ getName() }}
                                </span>
                            </span>
                        </div>
                        <div class="selenium-user-loggedin-dropdown" ngbDropdownMenu>
                            <div *ngIf="!isStudent" class="item">
                                <app-link
                                    [href]="'/dashboard/'"
                                    class="{{ gtmPrefix + 'dashboard' }}"
                                    [attr.data-gtmlabel]="'Dashboard'"
                                    >Dashboard</app-link
                                >
                            </div>

                            <div class="item">
                                <app-link
                                    [href]="'/favorites/'"
                                    class="{{ gtmPrefix + 'favorites' }}"
                                    [attr.data-gtmlabel]="'Favorites'"
                                    >Favorites</app-link
                                >
                            </div>

                            <div class="item">
                                <app-link
                                    [href]="'/folders/'"
                                    class="{{ gtmPrefix + 'folders' }}"
                                    [attr.data-gtmlabel]="'Folders'"
                                    >Folders</app-link
                                >
                            </div>

                            <div *ngIf="!isStudent" class="item">
                                <app-link
                                    [href]="'/tools/rosters/assignments'"
                                    class="{{ gtmPrefix + 'assignments' }}"
                                    [attr.data-gtmlabel]="'Assignments'"
                                    >Assignments</app-link
                                >
                            </div>

                            <div *ngIf="!isStudent" class="item">
                                <app-link
                                    [href]="'/tools/rosters/'"
                                    class="{{ gtmPrefix + 'rosters' }}"
                                    [attr.data-gtmlabel]="'Classes'"
                                    >Classes</app-link
                                >
                            </div>

                            <div *ngIf="!isStudent" class="item">
                                <app-link
                                    [href]="'/tools/'"
                                    class="{{ gtmPrefix + 'tools' }}"
                                    [attr.data-gtmlabel]="'Tools'"
                                    >Tools</app-link
                                >
                            </div>

                            <div *ngIf="!isStudent" class="item">
                                <app-link
                                    [appRouterLink]="['/profile/']"
                                    class="{{ gtmPrefix + 'profile' }}"
                                    [attr.data-gtmlabel]="'Profile'"
                                    >Profile</app-link
                                >
                            </div>

                            <div class="item">
                                <a
                                    [href]="userService.getLogoutUrl()"
                                    class="{{ gtmPrefix + 'logout selenium-logout' }}"
                                    [attr.data-gtmlabel]="'Logout'"
                                    >Logout
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="search">
                <app-external-search-input
                    [placeholder]="'Search'"
                    [type]="'for-header'"
                ></app-external-search-input>
            </div>

            <div class="burger-menu-icon">
                <app-icon
                    class="menu-icon"
                    *ngIf="!showBurgerMenu"
                    (click)="toggleMenu('burger-menu')"
                    [type]="'Menu'"
                ></app-icon>
                <app-icon
                    *ngIf="showBurgerMenu"
                    (click)="toggleMenu('burger-menu')"
                    [type]="'X'"
                ></app-icon>
            </div>

            <div class="auth-menu-icon">
                <app-icon
                    *ngIf="!showUserMenu"
                    (click)="toggleMenu('user-menu')"
                    [type]="'User'"
                ></app-icon>
                <app-icon
                    *ngIf="showUserMenu"
                    (click)="toggleMenu('user-menu')"
                    [type]="'X'"
                ></app-icon>
            </div>
        </div>
        <div class="container search-bar" [ngClass]="{ 'show-search': showTabletSearch }">
            <div>
                <app-external-search-input
                    [placeholder]="'Search'"
                    [type]="'for-header'"
                ></app-external-search-input>
            </div>
        </div>
    </div>

    <div class="mobile-menu">
        <div *ngIf="showUserMenu && userService.isLoggedIn()" class="user-menu container">
            <div *ngIf="!isStudent" class="item">
                <app-link
                    [href]="'/dashboard/'"
                    class="{{ gtmPrefix + 'dashboard' }}"
                    [attr.data-gtmlabel]="'Dashboard'"
                    >Dashboard</app-link
                >
            </div>
            <div class="item">
                <app-link
                    [href]="'/favorites/'"
                    class="{{ gtmPrefix + 'favorites' }}"
                    [attr.data-gtmlabel]="'Favorites'"
                    >Favorites</app-link
                >
            </div>
            <div class="item">
                <app-link
                    [href]="'/folders/'"
                    class="{{ gtmPrefix + 'folders' }}"
                    [attr.data-gtmlabel]="'Folders'"
                    >Folders</app-link
                >
            </div>
            <div *ngIf="!isStudent" class="item">
                <app-link
                    [href]="'/tools/rosters/assignments'"
                    class="{{ gtmPrefix + 'assignments' }}"
                    [attr.data-gtmlabel]="'Assignments'"
                    >Assignments</app-link
                >
            </div>
            <div *ngIf="!isStudent" class="item">
                <app-link
                    [href]="'/tools/rosters/'"
                    class="{{ gtmPrefix + 'rosters' }}"
                    [attr.data-gtmlabel]="'Classes'"
                    >Classes</app-link
                >
            </div>
            <div *ngIf="!isStudent" class="item">
                <app-link
                    [href]="'/tools/'"
                    class="{{ gtmPrefix + 'tools' }}"
                    [attr.data-gtmlabel]="'Tools'"
                    >Tools</app-link
                >
            </div>
            <div *ngIf="!isStudent" class="item">
                <app-link
                    [appRouterLink]="['/profile/']"
                    class="{{ gtmPrefix + 'profile' }}"
                    [attr.data-gtmlabel]="'Profile'"
                    >Profile</app-link
                >
            </div>
            <div class="item">
                <a
                    [href]="userService.getLogoutUrl()"
                    class="{{ gtmPrefix + 'logout' }}"
                    [attr.data-gtmlabel]="'Logout'"
                    >Logout</a
                >
            </div>
        </div>
        <div *ngIf="showBurgerMenu" class="nav-menu container">
            <div class="item nav-menu-search">
                <app-external-search-input
                    [placeholder]="'Search Classroom Resources'"
                    [type]="'for-header'"
                ></app-external-search-input>
            </div>
            <div class="item" *ngIf="!isStudent">
                <app-browse-by [mobileView]="true"></app-browse-by>
            </div>
            <div *ngIf="!userService.isLoggedIn()" class="item register">
                <app-register *ngIf="!isStudent" [nextURL]="nextUrl"></app-register>
                <app-register
                    [nextURL]="nextUrl"
                    [mobile]="true"
                    *ngIf="isStudent"
                    [student]="true"
                    [text]="'Sign In'"
                ></app-register>
            </div>
        </div>
    </div>
    <div *ngIf="isStudent" class="for-students-bar">FOR STUDENTS</div>
</header>

<app-main-navigation *ngIf="!isStudent"></app-main-navigation>
